import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { Origin } from '@classes/origin/origin';
import { OriginConfig } from '@classes/origin/origin-config';
import { UiService } from './ui.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class OriginService {
    originsListChanged = new Subject<Origin[]>();
    private baseUrl = environment.apiUrl + 'origins';

    constructor(
        private http: HttpClient,
        private uiSrv: UiService,
        private router: Router,
        private userSrv: UserService
    ) { }

    getList(): Observable<Origin[]> {
        this.uiSrv.loadingStateChanged.next(true);

        return this.http.get<Origin[]>(this.baseUrl)
        .pipe(
            tap(originsFromApi => {
                this.uiSrv.loadingStateChanged.next(false);

                this.originsListChanged.next([...originsFromApi]);
            })
        );
    }

    get(): Observable<Origin> {
        this.uiSrv.loadingStateChanged.next(true);

        return this.http.get<Origin>(`${this.baseUrl}/current`)
        .pipe(
            tap(() => {
                this.uiSrv.loadingStateChanged.next(false);
            })
        );
    }

    set(newParams: OriginConfig, noNavigation?: boolean): Observable<Origin> {
        this.uiSrv.loadingStateChanged.next(true);

        return this.http.post<Origin>(this.baseUrl, newParams)
        .pipe(
            tap(originFromApi => {
                this.uiSrv.loadingStateChanged.next(false);

                this.userSrv.setParametersOrigin(originFromApi);

                if(!noNavigation) {
                    this.uiSrv.showSnackbar("main.dialogs.originSubmit.summary", true);
                    this.router.navigate(['/simulation/live']);
                }
            })
        );
    }
}
